import {faWarning, faXCircle} from '@awesome.me/kit-d4c1b300b9/icons/kit/custom';
import {createContext} from '@chakra-ui/react-context';
import type {AlertStatus} from '@chakra-ui/react';
import type {IconDefinition} from '@fortawesome/fontawesome-svg-core';

import type {useToastStyleConfig} from '../../theme-config';
import {SpinnerIcon} from '../Spinner';

export const [ToastContextProvider, useToastContext] = createContext<ToastContext>({
  name: `ToastContext`,
  hookName: `useToastContext`,
  providerName: `<Toast />`,
});

export const [ToastStylesProvider, useToastStyles] = createContext<ReturnType<typeof useToastStyleConfig>>({
  name: `ToastStylesProvider`,
  hookName: `useToastStyles`,
  providerName: `<Toast />`,
});

const STATUSES = {
  info: {icon: null},
  warning: {icon: faWarning},
  success: {icon: null},
  error: {icon: faXCircle},
  loading: {icon: SpinnerIcon},
} as const;

export const getStatusIcon = (status: AlertStatus): IconDefinition | typeof SpinnerIcon | null => STATUSES[status].icon;

export interface ToastContext {
  status: AlertStatus;
}
